import { defineComponent as _defineComponent } from 'vue'
import {onMounted, ref} from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'PayoutNoneForm',
  emits: ['created', 'model-loaded'],
  setup(__props, { expose, emit }) {



const submitable = ref(false);

const setSourceAccountNumber = (value: string) => {
}

onMounted(() => {
  emit('created', false);
  emit('model-loaded');
});

expose({
  setSourceAccountNumber
});

return { __sfc: true,emit, submitable, setSourceAccountNumber, onMounted, ref }
}

})